<template>
  <div class="">
    <p v-html="datMsg"></p>
  </div>
</template>

<script>
import smpConfigUtil from '@/util/smp_config_utils';
export default {
  name: 'DATConnectionError',
  computed: {
    datMsg() {
      return smpConfigUtil.getDatConnectionConfig().message;
    }
  }
}
</script>
